/* eslint-disable */
import { createRequestClient } from "./createRequestClient";

export default createRequestClient();
